import React, { useState } from "react";
import { P3Desk } from "../../styles/styles_text";

import { useDispatch, useSelector } from "react-redux";
import AddNote from "./AddNote";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../../components/ui/accordion";
import { DashBoardActions } from "../../store/ducks/dashboard";
import Excluir from "../../assets/kinologyIcons/svg/delete.svg"

import moment from 'moment-timezone';

const ListNotes: React.FC = () => {

	const dispatch = useDispatch();

	const anotacoes = useSelector(
		(state: any) => state.dashboard.anotacoes_dynalabs.anotacoes
	);

	const DeleteNote = (id: any) => {
		dispatch(DashBoardActions.excluir_anotacao_dynalabs_request(id));
	};

	const [open, setOpen]: any = useState("");
	const handleAccordionChange = (value: string | string[]) => {
		console.log("Acordeon aberto:", value);
		setOpen(value)
	};

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				border: '1px, solid, #DEDFE3',
				borderRadius: '18px',
				padding: '1.2rem',
				marginTop: '1rem'
			}}>
			<AddNote type="default" />
			<P3Desk style={{ marginTop: "1rem", marginBottom: '1rem' }}>Histórico de anotações</P3Desk>
			{anotacoes?.length > 0 ? anotacoes.map((anotacao: any, index: number) => (
				<Accordion key={index} type="single" collapsible onValueChange={handleAccordionChange}>
					<AccordionItem value={"item-" + index}>
						<AccordionTrigger>
							<div style={{ width: '100%' }}>
								<p style={{ color: '#000E4B', fontSize: '0.9rem' }}>{moment.utc(anotacao.ANOTACAO_DASH_CRIADO).format("DD/MM/YYYY - HH:mm")}</p>
								<p style={{ color: '#797D8D', fontSize: '0.9rem', marginBottom: '0.5rem' }}>
									{open == "item-" + index ?
										<div style={{
											overflowWrap: 'break-word',
											wordBreak: 'break-word',
											whiteSpace: 'normal',
										}}>
											{anotacao.ANOTACAO_DASH_TXT}
										</div>
										:
										<div className="line-clamp-2" style={{
											overflowWrap: 'break-word',
											wordBreak: 'break-word',
											whiteSpace: 'normal',
										}}>
											{anotacao.ANOTACAO_DASH_TXT}
										</div>
									}
								</p>
								<hr />
							</div>
						</AccordionTrigger>
						<AccordionContent>
							<div style={{ display: 'flex', cursor: 'pointer', flexDirection: 'row', justifyContent: 'space-between' }}>
								<p></p>
								<AddNote edit={anotacao} type="default" />
								|
								<div style={{ display: 'flex', flexDirection: 'row', gap: 10 }}>
									<p style={{ fontSize: "0.9rem", color: '#2A3048', fontWeight: 400 }} onClick={() => DeleteNote(anotacao.ID_ANOTACAO_DASH)}>Excluir</p>
									<img src={Excluir} alt="" style={{ width: '0.8rem' }} />
								</div>

								<p></p>
							</div>
						</AccordionContent>
					</AccordionItem>
				</Accordion>

			)) :
				<P3Desk style={{ marginTop: "1rem" }}>Sem anotações</P3Desk>
			}
		</div>
	);
};

export default ListNotes;
